<template>
  <v-app id="inspire">
    <TheNavBar
      v-if="hasNavigationAndFooter && companyType"
      :key="companyType"
    />

    <v-content>
      <v-container fluid>
        <!-- {{$route.path}} -->
        <router-view :key="$route.path" v-show="showPage && requiredLoaded" @ready="pageReady"/>
        <AppSpinner v-show="!showPage" />
      </v-container>
    </v-content>

    <v-footer v-if="hasNavigationAndFooter" class="footer" :class="{'test-mode': isTestBuild}" app>
      <span class="white--text">(v2.0.0) &copy; 08.02.{{currentYear}}</span>
    </v-footer>
  </v-app>
</template>

<script>
import TheNavBar from '@/components/TheNavBar'
import { mapActions } from 'vuex'

export default {
  components: {
    TheNavBar
  },
  data: () => ({
    showPage: false,
    requiredLoaded: false
  }),
  computed: {
    hasNavigationAndFooter () {
      return !['Login', 'Register', 'MyCompanyReportsPrint', 'MyCompanyControlTapeDownload', 'MyCompanyInvoicePreview', 'MyCompanyAcceptanceFormsPreview', 'MyCompanyArhivPreview', 'MyCompanyAcceptanceFormPreview', 'MyCompanyWriteoffFormsPreview', 'MyCompanyCurrentStockPreview', 'MyCompanyMaterialDiaryPreview', 'MyCompanyGlobalInvoicesPreview', 'MyCompanyReportsDailyPreview'].includes(this.$route.name)
    },
    companyType () {
      if (this.$store.state.companies.myCompany) {
        return this.$store.state.companies.myCompany.company_type
      }
      return null
    },
    isTestBuild () {
      console.log(process.env.VUE_APP_MODE)
      return process.env.VUE_APP_MODE === 'test'
    },
    currentYear () {
      const today = new Date()
      return today.getFullYear()
    }
  },
  methods: {
    ...mapActions('companies', ['loadMyCompany']),
    ...mapActions('businessUnits', { loadBusinessUnits: 'loadItems' }),
    ...mapActions('auth', ['loadUser']),
    pageReady () {
      this.showPage = true
    },
    loadRequiredData () {
      const req = []
      if (this.$store.state.auth.userId && !this.$store.state.auth.user) {
        req.push(this.loadUser())
      }
      if (this.$store.state.auth.jwt) {
        req.push(this.loadMyCompany())
        req.push(this.loadBusinessUnits())
      }
      Promise.all(req)
        .then(() => {
          this.requiredLoaded = true
        })
    }
  },
  created () {
    this.loadRequiredData()
    this.$router.beforeEach((to, from, next) => {
      this.showPage = false
      next()
    })
  }
}
</script>

<style>
@import "assets/scss/global.scss";
@import url('https://fonts.googleapis.com/css?family=Open+Sans|Roboto&display=swap');
.awn-toast-label,
.awn-toast-content {
  font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
</style>

<style lang="scss" scoped>
.footer {
  $hr-dark-green: #0F998E;
  $hr-light-green: #6FC171;
  background-image: linear-gradient(to right, #464856 , #464856);
  &.test-mode {
    background-image: linear-gradient(to right, $hr-dark-green , $hr-light-green);
  }
}
</style>
